<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-07 14:15:05
 -->
<template>
  <ul class="part11">
    <div class="title">同时提交下列文件 The following documents are enclosed</div>
    <ul class="lis">
      <li>
        <el-checkbox v-model="part11.activityRecord" :disabled="stateCode==6||stateCode==0?false:true">合唱团录音</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part11.activityRecord"
          :disabled="stateCode==6||stateCode==0?false:true"
        >A sound recording</el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part11.activitySynopsis" :disabled="stateCode==6||stateCode==0?false:true">合唱团简介</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part11.activitySynopsis"
          :disabled="stateCode==6||stateCode==0?false:true"
        >Short biography</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part11.activityPhoto"
          :disabled="stateCode==6||stateCode==0?false:true"
        >可以进行再制作的合唱团照片</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part11.activityPhoto"
          :disabled="stateCode==6||stateCode==0?false:true"
        >Reproducible photo</el-checkbox>
      </li>
    </ul>
  </ul>
</template>

<script>
export default {
  props: {
    documentsh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      checked: false,
      part11: {
        activityRecord: false,
        activitySynopsis: false,
        activityPhoto: false,
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part11.activityRecord = this.documentsh.activityRecord;
      this.part11.activitySynopsis = this.documentsh.activitySynopsis;
      this.part11.activityPhoto = this.documentsh.activityPhoto;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part11 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 100px;
  }
  .lis {
    li {
      border: 1px solid gainsboro;
      margin-left: 100px;
      margin-right: 100px;
      padding-left: 10px;
      padding-right: 0px;
      .el-checkbox {
        line-height: 34px;
        /deep/ .el-checkbox__label {
          color: rgba(36, 85, 139, 1);
          input {
            outline: none;
            border: 0;
            border-bottom: 1px solid gray;
          }
        }
      }
    }
  }

  li {
    display: flex;
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 20px;

    /deep/ .el-input-group__prepend {
      border-right: 0;
      color: rgba(36, 85, 139, 1);
      background: white;
    }

    .radiobox {
      width: 30%;
      border: 1px solid gainsboro;
      .el-radio {
        margin-left: 30px;
        margin-top: 14px;
      }
    }
    p {
      color: rgba(36, 85, 139, 1);
      line-height: 32px;
    }
  }

  li:nth-of-type(3) {
    margin-top: 30px;
  }

  li:nth-of-type(5) {
    margin-top: 30px;
  }
  li:nth-of-type(7) {
    margin-top: 30px;
  }
  li:nth-of-type(9) {
    margin-top: 30px;
  }
  li:nth-of-type(11) {
    margin-top: 30px;
  }
  li:nth-of-type(13) {
    margin-top: 30px;
  }
}
</style>
